module.exports = __webpack_public_path__ + "static/media/1.b63907de.png";